export const MAX_REDEMPTIONS_PER_PERSON_CLOSED_COUPON = -1;

export const TYPE_OPTIONS = [
	{ id: 'REGULAR', label: 'REGULAR' },
	{ id: 'EXCLUSIVE', label: 'EXCLUSIVE' },
	{ id: 'INSURANCE', label: 'INSURANCE' }
];

export const ALLOWED_PAYMENT_MODES_OPTIONS = [{ id: 'UPI', label: 'UPI' }];

export const ALLOWED_PLATFORMS_OPTIONS = [
	{ id: 'ios', label: 'IOS' },
	{ id: 'android', label: 'ANDROID' },
	{ id: 'web', label: 'WEB' }
];

export interface UserlistData {
	code: string;
	uids: number[];
	maxRedemptions: number;
}
